import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router';
import A11y from 'chameleon/ui-stack/utilities/a11y';
import { AP_CALCULUS_BC } from 'chameleon-src/constants/subjects';

const prependDomainToTarget = (targetSlug) => {
  const hn = window.location.hostname;
  const subdomain = hn.split('.')[0]; // "apclassroom-testing"
  const fymEnv = subdomain.split('-')[1]; // "testing"

  const domainMaps = {
    testing: 'cb.testing.academicmerit.com',
    uat: 'apc-pl-uat.collegeboard.org',
    local: 'http://cb.test:8000/n/pl#',
  };

  // prod have no fymEnv so use the default cb.academicmerit.com
  const domain = domainMaps[fymEnv] || 'cb.academicmerit.com';
  return fymEnv === 'local'
    ? `${domain}${targetSlug}`
    : `${window.location.protocol}//${domain}/n/pl#${targetSlug}`;
};

export const getAuthenticatedProfessionalLearningLink = (
  subject,
  plTargetUrl,
) => {
  const accountAccessToken = window.localStorage.getItem(
    'account_access_token',
  );
  const accountRefreshToken = window.localStorage.getItem(
    'account_refresh_token',
  );
  const expires = window.localStorage.getItem('expires');
  let nextUrl = prependDomainToTarget(plTargetUrl);

  /**
   * Done for https://academicmerit.atlassian.net/browse/FY-18711
   * Professional Learning resolves calculus to 25 (Calculus AB) whether or not
   * we are from AB/ BC. This is to ensure that if we come from Calc BC, we retrieve
   * the correct subject data from the PL logic.
   */
  if (subject && parseInt(subject, 10) === AP_CALCULUS_BC) {
    nextUrl += '?calcbc=1';
  }

  const urlParams = `?next=${encodeURIComponent(
    nextUrl,
  )}&jwt=${accountAccessToken}&refresh=${accountRefreshToken}&expires=${expires}`;

  // Build temp a element to Extract URL
  const l = document.createElement('a');
  l.href = nextUrl;
  const redirectHost = `${l.protocol}//${l.hostname}${
    l.port ? `:${l.port}` : ''
  }`;
  return `${redirectHost}/n/auth/redirect/${urlParams}`;
};

const ProfessionalLink = ({ url, children, params, ...rest }) => {
  const { subject } = params;

  return (
    <A11y>
      <Link
        data-test-subunit-url
        to={getAuthenticatedProfessionalLearningLink(subject, url)}
        target="_blank"
        {...rest}
      >
        {children}
      </Link>
    </A11y>
  );
};

ProfessionalLink.propTypes = {
  url: PropTypes.string.isRequired,
};

export default withRouter(ProfessionalLink);
